import constructPaymentLink from './construct-payment-link.js';
import constructTokenAmount from './construct-token-amount.js';
import doAddCard from './do-add-card.js';
import doChangeCurrentCard from './do-change-current-card.js';
import fetchTransactionInfo from './fetch-transaction-info.js';
import {aesEncryptString, aesDecryptString, rsaEncryptString, rsaDecryptString, signString, validateStringSignature} from './encryption.js';
import {fetchAccountBalance} from './account-info.js';

const handleMessage = async (theapp, settings_entry, params) => {
	console.log('handleMessage called');

	if (!theapp || !settings_entry || !params)
	return;

	if (params.handled === true)
		return;
		
	params.handled = true

	try {
		switch(params.action) {
			// support api
			case 'fetchTransactionInfo': {
					let tx_info = await fetchTransactionInfo(theapp, settings_entry, params.transaction_hash);
					theapp.answerRequest(params, {tx_info: tx_info});
				}
				break;

			case 'fetchAccountBalance': {
					let balance = await fetchAccountBalance(theapp, settings_entry, params.address);
					theapp.answerRequest(params, {balance: balance});
				}
				break;

			case 'computeWebPaymentLink': {
					let payment_link = await constructPaymentLink(theapp, settings_entry, params.xtra_params);
					theapp.answerRequest(params, {url: payment_link});
				}
				break;

			case 'computeTokenAmount': {
					let tokenamount = await constructTokenAmount(theapp, settings_entry, params.amount);
					theapp.answerRequest(params, {amount: tokenamount});
				}
				break;

				
			case 'computeAesEncryptString': {
					let cyphertext = await aesEncryptString(theapp, settings_entry, params.plaintext);
					theapp.answerRequest(params, {plaintext: params.plaintext, cyphertext});
				}
				break;

			case 'computeAesDecryptString': {
					let plaintext = await aesDecryptString(theapp, settings_entry, params.cyphertext);
					theapp.answerRequest(params, {plaintext, cyphertext: params.cyphertext});
				}
				break;
		
			case 'computeRsaEncryptString': {
					let cyphertext = await rsaEncryptString(theapp, settings_entry, params.rsapublickey, params.plaintext);
					theapp.answerRequest(params, {plaintext: params.plaintext, rsapublickey: params.rsapublickey, cyphertext});
				}
				break;

			case 'computeRsaDecryptString': {
					let plaintext = await rsaDecryptString(theapp, settings_entry, params.rsapublickey, params.cyphertext);
					theapp.answerRequest(params, {plaintext, rsapublickey: params.rsapublickey, cyphertext: params.cyphertext});
				}
				break;

			case 'computeSignString': {
					let signature = await signString(theapp, settings_entry, params.plaintext);
					theapp.answerRequest(params, {plaintext: params.plaintext, signature});
				}
				break;
			
			case 'computeValidateStringSignature': {
					let valid = await validateStringSignature(theapp, settings_entry, params.address, params.plaintext, params.signature);
					theapp.answerRequest(params, {valid, address: params.address, plaintext: params.plaintext, signature: params.signature});
				}
				break;
				
			// request for actions
			case 'doAddCard': {
				let card_address = await doAddCard(theapp, settings_entry, params.address, params.privatekey);
				theapp.answerRequest(params, {card_address});
			}
			break;

			case 'doChangeCurrentCard': {
				let card_address = await doChangeCurrentCard(theapp, settings_entry, params.address);
				theapp.answerRequest(params, {card_address});
			}
			break;

				
			default:
					break;
		}
	}
	catch(e) {
		console.log('exception in handleMessage: ' + e);
	}

}

export default handleMessage;